import { defineMessages } from "react-intl";

const messages = defineMessages({
  Services: "Dienstleistungen",
  about: "Über",
  add_extra_cost: "Weitere Kosten hinzufügen",
  add_group: "Gruppe hinzufügen",
  add_payment: "Zahlung hinzufügen",
  administration: "Administrator",
  administrator: "Administrator",
  after_order: "nach Bestellung",
  alibaba: "Alibaba-Konto",
  all: "Gesamt",
  all_revenues: "Alle Einnahmen",
  amazon: "Amazon",
  amazon_advertising_costs: "Amazon-Werbekosten (PPC)",
  amount: "Menge",
  amount_tooltip: "Währung in die alle anderen Währungen konvertiert werden",
  app_name: "Gorilla Tool",
  back: "Zurück",
  base_data: "Stammdaten",
  break_even: "Break-even",
  bubble_wrap: "Luftpolsterfolie",
  calculation: "Berechnung",
  calculations: "Berechnungen",
  calculaze: "Berechnen",
  cancel: "Abbrechen",
  categories: "Kategorien",
  companies: "Unternehmen",
  company: "Unternehmen",
  contact: "Ansprechpartner",
  cost: "Kosten",
  costs: "Kosten",
  countries: "Länder",
  country: "Land",
  create_company: "Unternehmen hinzufügen",
  currencies: "Währungen",
  currency: "Währung",
  dashboard: "Dashboard",
  days: "Tage",
  db1_marge: "DB1 Marge",
  db1_marge_after_advertising: "DB1 Marge nach Werbung",
  de: "Deutsch",
  default: "Standard",
  default_letter_size_label: "Standard Briefumschlag",
  default_oversize_size_label: "Standard Übergröße",
  default_package_size_label: "Standard Paket",
  default_size: "Standardgröße",
  delete: "Löschen",
  delete_calculation_dialog_message: "Berechnung wird dauerhaft gelöscht?",
  delete_calculation_dialog_title: "Berechnung löschen?",
  delete_category_dialog_message: "Kategorie wird dauerhaft gelöscht?",
  delete_category_dialog_title: "Kategorie löschen?",
  delete_company_dialog_message: "Unternehmen wird unwiderruflich gelöscht!",
  delete_company_dialog_title: "Unternehmen löschen",
  delete_country_dialog_message: "Land wird unwiderruflich gelöscht!",
  delete_country_dialog_title: "Land löschen",
  delete_curremcy_dialog_message: "Währung wird unwiderruflich gelöscht!",
  delete_currency_dialog_title: "Währung löschen",
  delete_item_dialog_message: "Produkt wird unwiderruflich gelöscht?",
  delete_item_dialog_title: "Produkt löschen",
  delete_market_dialog_message: "Markt wird dauerhaft gelöscht?",
  delete_market_dialog_title: "Markt löschen?",
  delete_shipping_dialog_message: "Der Versand wird dauerhaft gelöscht?",
  delete_shipping_dialog_title: "Versand löschen?",
  delete_supplier_dialog_message: "Lieferant wird unwiderruflich gelöscht!",
  delete_supplier_dialog_title: "Lieferant löschen",
  delete_template_dialog_message: "Vorlage wird dauerhaft gelöscht?",
  delete_template_dialog_title: "Vorlage löschen?",
  delete_versions_dialog_message: "Version wird dauerhaft gelöscht?",
  delete_versions_dialog_title: "Version löschen?",
  delivery_time: "Lieferdauer",
  description: "Beschreibung",
  differentFee: "abweichende Gebühr",
  disposal_costs: "Entsorgungskosten",
  disposal_fee: "Entsorgungsgebühr",
  disposal_fees: "Entsorgungsgebühren",
  disposal_rate: "davon Entsorgungensquote",
  ean: "EAN / GTIN",
  efn_label: "EFN",
  email: "E-Mail",
  en: "Englisch",
  expenses: "Ausgaben",
  fee: "Gebühr",
  file_upload_text: "Bild hier ablegen für",
  filter: "Filter",
  finish: "Fertig",
  first_revenue: "Erste Einnahmen von",
  fix_costs: "Fixkosten",
  foil_pouch: "Folienbeutel",
  fold_rule: "3-fach-Regel",
  fold_rule_message:
    "Dein Brutto-Verkaufserlös ist rund {revenue} Mal größer als Dein Bezugspreis!",
  goal_currency: "Zielwährung",
  green: "Grün",
  gross_item_price: "Brutto-Verkaufspreis",
  gross_sales_proceeds: "Brutto-Verkaufserlös",
  home: "Startseite",
  in_week: "in Woche",
  install: "Install",
  is_customs_label: "Zoll",
  is_tax_label: "Ist Dein Unternehmen umsatzsteuerpfilchtig?",
  is_vat_label: "Ist Dein Unternehmen umsatzsteuerpfilchtig?",
  item: "Produkt",
  items: "Produkte",
  labeling: "Beschriftung",
  language: "Sprache",
  large_letter_size_label: "Großer Briefumschlag",
  large_oversize_size_label: "Große Übergröße",
  extra_large_letter_size_label: "Extra großer Briefumschlag",
  small_package_size_label: "Kleines Paket",
  later: "Später",
  limitAmount: "Grenzbetrag",
  liquidity: "Liquitität",
  local_label: "Lokal",
  m3_period: "Zeitraum",
  m3_period_js: "Jan-Sep",
  m3_period_od: "Okt-Dez",
  marketing_costs: "Marketingkosten",
  markets: "Märkte",
  max: "Sollte weniger sein als 100",
  max_length: "Längste Seite",
  max_weight_brutto: "max Gewicht brutto",
  menu: "Menü",
  menu_mini_mode: "Mini-Menü",
  minFee: "Mindestsgebühr",
  min_length: "Kürzeste Seite",
  months: "Monate",
  my_account: "Mein Konto",
  name: "Name",
  name_tooltip: "Name der Version",
  net_sales: "Netto-Verkaufserlös",
  new_cost: "Neuer Kostenpunkt",
  new_template: "Neue Vorlage",
  next: "Weiter",
  none: "Keiner",
  number: "Muss eine Zahl sein",
  offline: "Offline",
  over_size: "Übergröße",
  own_category_label: "Eigene Kategorie",
  own_weight: "Eigengewicht",
  packaging_opaqued: "Verpackung undurchsichtig",
  packaging_tape: "Vepackungs Band",
  page_not_found: "Seite nicht gefunden",
  pan_eu_label: "PAN EU",
  part: "Anteil",
  password: "Passwort",
  payment_days: "Zahlung nach",
  payment_percent: "Anteil",
  per_piece: "pro Stück",
  percent_paymentMessage: "davon {Prozent}%",
  phone: "Telefon",
  place: "Ort",
  preparation_costs: "Vorbereitungskosten",
  product: "Produkt",
  production_costs: "Produktkosten",
  production_time: "Produktionsdauer",
  receipt: "Wareneigang von ",
  red: "Rot",
  reorder: "Nachbestellung von",
  repackaging_costs: "Umverpackungskosten",
  report: "Bericht",
  required: "Erforderlich",
  result_calculation: "Entwurfskalkulation",
  result_flow: "Kapital- und Warenfluss",
  return_costs: "Rücksendekosten",
  return_rate: "Rücksendequote",
  revenue: "Einnahmen",
  roas: "ROAS",
  roi_report_message: "Dein ROI liegt bei {roi}%!",
  roi_report_title: "Kapitalrendite (ROI)",
  roles: "Rollen",
  ru: "Russisch",
  rule: "Regel",
  sales: "Absatz",
  save: "Speichern",
  select_category: "Amazon Kategorie",
  select_company: "Unternehmen auswählen",
  select_item: "Produkt auswählen",
  select_market: "Markt auswählen",
  select_supplier: "Lieferant auswählen",
  select_template: "Vorlage auswählen",
  selling_costs: "Verkaufskosten",
  settings: "Einstellungen",
  shipping: "Versandprogramm",
  shipping_costs: "Versandkosten",
  shipping_fee: "Versandgebühren",
  shipping_fees: "Versandgebühren",
  shipping_size: "Paketgröße",
  shipping_to_amazon_warehouse_costs: "Versand an Amazon Lager",
  shippings: "Versandprogramme",
  sign_in: "Anmelden",
  sign_out: "Abmelden",
  simple: "Einfach",
  single_cost: "Stück",
  single_item: "Stück",
  sku: "SKU",
  skype: "Skype-Account",
  small_letter_size_label: "Kleiner Briefumschlag",
  small_light_mid_eu: "Small & Light Mitteleuropa",
  mid_eu: "Mitteleuropa",
  small_light_label: "Small & Light",
  small_oversize_size_label: "Kleine Übergröße",
  oversize_size_label: "Übergröße",
  sold_in_months: "Monate bis Bestellmenge verkauft ist",
  sponsored_rate: "Gesponsorte Käufe",
  standard: "Standard",
  start_new_version: "Neue Berechnung starten",
  stock: "Lagerbestand",
  stock_empty: "Lager leer",
  storage_costs: "Lagerkosten",
  storage_fee_js: "Jan-Sep",
  storage_fee_od: "Okt-Dez",
  storage_fees: "Lagergebühren",
  supplier: "Lieferant",
  suppliers: "Lieferanten",
  taric_code: "TARIC Code",
  tariff_preference: "Zollpräferenz",
  tasks: "Aufgaben",
  tax: "Umsatzsteuer",
  tax_rate: "Umsatzsteuersatz",
  template: "Vorlage",
  templates: "Vorlagen",
  test: "Verteilung des Netto-Verkaufserlös",
  theme: "Thema",
  third_country_duty_rate: "Drittlandszollsatz",
  total_cost: "Gesamt",
  total_needs: "Gesamter Kapitalbedarf",
  total_revenue: "Gesamteinnahmen",
  translations: "Übersetzungen",
  turnover: "Umsatz",
  update: "Update",
  update_available: "Update verfügbar!",
  usage_of_amazon_services: "Verwendung von Amazon-Diensten",
  user: "Benutzer",
  username: "Nutzername",
  users: "Benutzer",
  users_page: "Benutzer {amount}",
  variable_costs: "variable Kosten",
  variant: "Variante",
  variant_label: "Variante",
  versions: "Versionen",
  website: "Website",
  weight: "Gewicht",
  weight_from: "Gewicht von",
  weight_to: "Gewicht bis",
  width: "Breite",
  yes: "Ja",
  zero: "Sollte größer als 0 sein",
  enable_notifications:
    "Benachrichtigungen aktivieren? Wir informieren dich falls sich die Amazon Preise ändern.",
  enable: "Aktivieren",
  no_thanks: "Vieleicht später",
  month: "Monat",
  year: "Jahr",
  buy: "Kaufen",
  budy_confirmation_text:
    "Ich stimme ausdrücklich zu, dass Gorilla Tool mit der Vertragserfüllung vor Ablauf der Widerrufsfrist beginnt. Ich weiß, dass durch diese Zustimmung mit Beginn der Vertragserfüllung mein Widerrufsrecht erlischt.",
});

export default messages;
